import React from 'react';

export const SaveButton = props => {
	const [active, setActive] = React.useState(false);

	const button = React.useRef(null);

	React.useEffect(() => {
		props.setSaving && props.setSaving(active);
		active && props.onClick({ target: button.current });
	}, [active]);

	const click = () => {
		setActive(new Date());
	};

	const keyPressed = e => {
		if (e.key === 'Enter') {
			click(e);
		}
	};

	const { id, saving, icon, children, dispatch, setSaving, ...cleanProps } = props;

	return (
		<button
			data-testid={id ? `save-${id}` : undefined}
			ref={button}
			{...cleanProps}
			onKeyUp={e => keyPressed(e)}
			onClick={e => click(e)}
			disabled={saving || props.disabled}
		>
			{icon && (!saving || !active) && <i className={`fa ${icon} mr10`} />}
			{saving && active && <i className="fa fa-spin fa-cog mr10" />}
			{children}
		</button>
	);
};

export default SaveButton;
